<template>
  <app-dialog class="text-center" @close="$emit('close')">
    <template #title>New Player</template>
    <v-row dense justify="center">
      <v-col :cols="12" class="field px-10">
        <v-text-field clearable v-model="name" label="Player Name"/>
      </v-col>
      <v-col :cols="12" class="field">
        <app-drop-down-menu setting="instrument"
                            :options="instruments"
                            :currently-selected="instrument"
                            @updated="setState"
                            text="Instrument: "/>
      </v-col>
      <v-col :cols="12" class="pa-7">
        <v-btn class="body-1"
               color="success"
               @click="setup">
          Add
        </v-btn>
      </v-col>
    </v-row>
  </app-dialog>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex'
  import {instruments}            from 'misc/Constants'

  export default {
    name: 'TheAddPlayerDialog',

    components: {
      AppDropDownMenu: () => import(/* webpackChunkName: "components" */ 'components/AppDropDownMenu'),
      AppDialog:       () => import(/* webpackChunkName: "app-main" */ 'components/AppDialog'),
    },

    props: {
      score: Object,
    },

    data() {
      return {
        name:       '',
        instruments,
        instrument: 'Choose',
      }
    },

    computed: {
      ...mapGetters('transport', ['getScore', 'getNumberOfPlayers']),
    },

    methods: {
      ...mapActions('transport', ['addPlayer']),

      setState({setting, value}) {
        this[setting] = value
      },

      setup() {
        if (this.instrument !== 'Choose' && this.name) {
          this.addPlayer({name: this.name, instrument: this.instrument})
          this.score.addVoice(this.name)
          this.$store.dispatch('transport/initPlayersInstruments')
          this.$emit('onPlayerAdded')
        } else {
          this.$store.dispatch('view/setSnackbar', {
            text:    'Please enter a name and choose an instrument!',
            timeout: 4000,
            active:  true,
          })
        }
      },
    },
  }
</script>

<style scoped>
</style>
